module.exports = __webpack_public_path__ + "img/orange_017.dfa092b0.png";